export default "__VITE_ASSET__CqWdv4n5__"